import React from 'react';

interface Props {
	className?: string;

}

export function KodieIcon({ className }: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4637 0.705846C14.9806 0.151632 18.246 2.77731 20.3132 5.66841C22.2476 8.37377 22.6079 11.8391 21.7129 15.0398C20.8716 18.0479 18.5936 20.279 15.8213 21.7311C12.8954 23.2636 9.47921 24.4126 6.48615 23.0151C3.46465 21.6044 1.60858 18.3184 1.39965 14.9976C1.22064 12.1524 3.8984 10.3293 5.54123 7.99633C7.43749 5.30349 8.20476 1.21943 11.4637 0.705846Z"
				fill="#8252DD"
			/>
			<path
				d="M11.3185 13.6669C10.6405 11.5756 11.7861 9.33053 13.8775 8.65246C15.9688 7.97439 18.2138 9.12006 18.8919 11.2114C19.5699 13.3027 18.4243 15.5477 16.333 16.2258C14.2416 16.9039 11.9966 15.7582 11.3185 13.6669Z"
				fill="white"
			/>
			<path
				d="M6.99433 15.9276C5.318 14.5052 5.11217 11.9932 6.53459 10.3168C7.95702 8.64049 10.4691 8.43466 12.1454 9.85709C13.8217 11.2795 14.0276 13.7916 12.6051 15.4679C11.1827 17.1442 8.67066 17.3501 6.99433 15.9276Z"
				fill="white"
			/>
			<path
				d="M5.82112 8.20681L9.87093 6.81722C10.2676 6.68113 10.6994 6.89234 10.8355 7.28898L11.1009 8.06227C11.237 8.45891 11.0258 8.89077 10.6291 9.02687L6.5793 10.4165C6.18266 10.5525 5.75079 10.3413 5.61469 9.9447L5.34936 9.17141C5.21327 8.77477 5.42448 8.3429 5.82112 8.20681Z"
				fill="#000A23"
			/>
			<path
				d="M14.5666 5.26799L18.7233 6.29452C19.1304 6.39506 19.3789 6.80659 19.2784 7.2137L19.0824 8.00739C18.9819 8.4145 18.5703 8.66303 18.1632 8.56249L14.0065 7.53596C13.5994 7.43542 13.3509 7.02389 13.4514 6.61678L13.6474 5.82309C13.748 5.41598 14.1595 5.16745 14.5666 5.26799Z"
				fill="#000A23"
			/>
			<path
				d="M12.3187 13.4739C12.0232 12.2799 12.7515 11.0724 13.9455 10.7768C15.1394 10.4812 16.347 11.2095 16.6425 12.4035C16.9381 13.5975 16.2098 14.805 15.0158 15.1006C13.8218 15.3962 12.6143 14.6679 12.3187 13.4739Z"
				fill="#000A23"
			/>
			<path
				d="M8.61396 14.9486C7.67608 14.1527 7.56092 12.7473 8.35674 11.8094C9.15257 10.8715 10.558 10.7564 11.4959 11.5522C12.4338 12.348 12.5489 13.7535 11.7531 14.6914C10.9573 15.6292 9.55184 15.7444 8.61396 14.9486Z"
				fill="#000A23"
			/>
			<path
				d="M12.1834 18.9029C11.3422 18.8161 10.7001 18.1526 10.6089 17.3454C10.5852 17.1357 10.7774 16.9815 10.9872 17.0032L13.7423 17.2875C13.9522 17.3091 14.1088 17.4993 14.0428 17.6997C13.7888 18.4713 13.0246 18.9897 12.1834 18.9029Z"
				fill="#27292C"
			/>
		</svg>
	);
}
